<script>
import { Doughnut, mixins } from "vue-chartjs";
import _ from "../../views/Utility/utility";
const { reactiveProp } = mixins;

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: {
    pieChartType: String,
    isHalf: Boolean,
    legendFontSize: Number,
  },
  computed: {
    options() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          enabled: true,
          titleFontSize: 14,
          titleMarginBottom: 8,
          bodyFontSize: 15,
          bodySpacing: 10,
          callbacks: {
            label: (tooltipItems, data) => {
              const index = tooltipItems.index;
              return data.labels[index];
            },
          },
          legendTemplate: "<h1>Hii</h1>",
        },
        rotation: this.isHalf ? 1 * Math.PI : 0,
        circumference: this.isHalf ? 1 * Math.PI : 2 * Math.PI,
        legend: {
          position: "right",
          align: "center",
          fullWidth: true,
          labels: {
            fontSize: this.legendFontSize ?? 16,
          },
          onClick: this.handleClickOption,
        },
        onClick: (pointEvent, item) => {
          if (item[0]) {
            const index = item[0]._index;
            const text = item[0]._model.label;

            this.$emit("on-receive", {
              index: index,
              text: text,
            });
          }
        }
      };
    },
  },
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options);
  },
  methods: {
    handleClickOption(pointEvent, element) {
      this.$emit("on-receive", {
        index: element.index,
        text: element.text
      });
    },
  },
};
</script>